import React from "react";

/**
 * CopyBlock: watching pill + headline + sub.
 * Sits in Fold 1 column 1. The URL launch bar is a separate grid node
 * (UrlLaunchBar) so mobile order is copy → podium → URL.
 */
export const CopyBlock = ({ visitors, online }) => {
  const showOnline = online != null && !Number.isNaN(Number(online)) && Number(online) > 0;

  return (
    <div data-testid="copy-block" className="copy-block flex flex-col">
        <div data-testid="copy-watching-pill" className="copy-badge mono self-start">
          <span className={`dot ${showOnline ? "blink" : ""}`} />
          <span className="hidden sm:inline">
            {showOnline && (
              <>
                <span className="text-emerald-400">
                  {Number(online).toLocaleString()} WATCHING
                </span>
                <span className="mx-1.5 text-slate-600">·</span>
              </>
            )}
            <span>{Number(visitors || 0).toLocaleString()} VISITORS</span>
          </span>
          <span className="sm:hidden">
            {showOnline && (
              <>
                <span className="text-emerald-400">{Number(online).toLocaleString()}</span>
                <span className="mx-1 text-slate-600">·</span>
              </>
            )}
            {Number(visitors || 0).toLocaleString()}
          </span>
        </div>

        <h1 data-testid="copy-headline" className="copy-headline">
          Every creator deserves <span className="accent">to be seen.</span>
        </h1>

        <p data-testid="copy-sub" className="copy-sub">
          A pay-to-rank leaderboard for creators. Paste your link, take a spot, get discovered. Every listing moves Sam closer to Earth.
        </p>
    </div>
  );
};
